import { ISessionTokenResponseSchema } from '@cian/chats-api/lib/browser-entry';
import { TMeta } from '@cian/logger/shared';

import { fetchUsersSession as _fetchUsersSession, TUsersSessionResponse } from '../repositories/chats/v1/users/session';
// eslint-disable-next-line import/no-cycle
import { IApplicationContext } from '../types/applicationContext';

type TFetchUsersSessionParams = {
  cookies?: string;
  timezone?: number;
};

function isSessionToken(obj: {}): obj is ISessionTokenResponseSchema {
  return obj && 'expiration' in obj && 'sessionToken' in obj && 'userId' in obj;
}

export async function fetchUsersSession(
  { httpApi, logger, custom }: IApplicationContext,
  { cookies, timezone }: TFetchUsersSessionParams,
) {
  try {
    const { statusCode, response }: TUsersSessionResponse = await _fetchUsersSession({
      httpApi,
      parameters: { timezone },
      config: {
        requestConfig: {
          headers: cookies ? [['Cookie', cookies]] : [],
          withCredentials: true,
        },
      },
    });

    if (statusCode >= 400) {
      // Пользователь не авторизован
      return null;
    }

    if (!isSessionToken(response)) {
      const { serializableMap, messagesMap, socket, ...rest } = custom;

      logger.warning('Невалидный ответ от сервера', {
        message: 'Не удалось получить токен сессии, код ответа = ' + statusCode,
        domain: 'src/shared/services/fetchUsersSession.ts',
        ...((response as unknown as TMeta) || { errors: ['Отсутствует тело ответа'] }),
        ...rest,
      });

      return null;
    }

    return response;
  } catch (error) {
    const { serializableMap, messagesMap, socket, ...rest } = custom;

    logger.error(error, {
      message: 'Не удалось получить токен сессии',
      domain: 'src/shared/services/fetchUsersSession.ts',
      ...rest,
    });

    return null;
  }
}
